import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Grid, GridColumn } from '@/design-system/atoms/Grid';
import { Image } from '@/design-system/atoms/Image';
import { RichTextEditor } from '@/design-system/atoms/RichTextEditor';
import { Title } from '@/design-system/atoms/Title';

import styles from './ResultsMessage.module.scss';

/**
 * The ResultsMessage Component is used to display No Results messaging and Error messaging
 *
 */
const ResultsMessage = ({
    media,
    illustration,
    image,
    title,
    description,
    className,
    analytics,
    ...props
}) => {
    return (
        <div className={classnames(styles['results-message'], className)} {...props}>
            <ContentContainer>
                <Grid isContainerQuery>
                    <GridColumn
                        colSpan={{
                            sm: 4,
                            md: 6,
                            lg: 12,
                        }}
                    >
                        {media === 'illustration' && illustration && (
                            <div className={styles['results-message__illustration']}>
                                {/* Illustration FPO */}
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162 162">
                                    <rect width="162" height="162" fill="#cccccc"></rect>
                                    <text x="50%" y="50%" textAnchor="middle">
                                        162x162
                                    </text>
                                </svg>
                            </div>
                        )}
                        {media === 'image' && image && (
                            <div className={styles['results-message__image']}>
                                <Image
                                    {...image}
                                    mobileAspectRatio={Image.ASPECT_RATIO['1:1']}
                                    defaultAspectRatio={Image.ASPECT_RATIO['1:1']}
                                    roundedCorners={true}
                                />
                            </div>
                        )}
                        <div className={styles['results-message__title']}>
                            <Title tag="h5" variant={Title.VARIANT.H5} content={title} />
                        </div>
                        {description && (
                            <div className={styles['results-message__description']}>
                                <RichTextEditor text={description} analytics={analytics} />
                            </div>
                        )}
                    </GridColumn>
                </Grid>
            </ContentContainer>
        </div>
    );
};

ResultsMessage.displayName = 'Results Message';

ResultsMessage.propTypes = {
    /** Media type to display */
    media: PropTypes.oneOf(['image', 'video']),
    /** Illustration */
    illustration: PropTypes.object,
    /** Image */
    image: PropTypes.shape(Image.propTypes),
    /** Title */
    title: PropTypes.string.isRequired,
    /** HTML content */
    description: PropTypes.string,
};

export default ResultsMessage;
